import Axios from 'axios';
import ClearIcon from '../../assets/icons/ClearIcon';
import { ActionT } from '../../framework/framework/components/Types';
import * as style from './style.css';
import ErrorsComp from '../errors/ErrorsComp';
import React = require('react');

interface IProps {
    value: string;
    onChange: ActionT<string>;
    onKeyDown: ActionT<string>;
    placeholder: string;
    type?: string;
    autoComplete?:string;
    errors?: string[];
}

interface IState {

}

export default class TextInput extends React.Component<IProps, IState> {
    axios = Axios;

    render() {
        return (
            <div className={style.textInputWrapper}>
                <div className={style.inputWrapper}>
                    <input type={this.props.type || 'text'}
                        value={this.props.value}
                        onChange={(e) => this.props.onChange(e.target.value)}
                        onKeyDown={(e) => this.props.onKeyDown(e.key)}
                        autoComplete={this.props.autoComplete || ''}
                        placeholder={this.props.placeholder}>
                    </input>
                    {this.textIsSet() && this.props.onChange &&
                        <ClearIcon onClick={() => this.props.onChange('')} />
                    }
                    {this.props.children}

                </div>
                <ErrorsComp errors={this.props.errors}/>
            </div>
        );
    }

    textIsSet() {
        return this.props.value.length > 0;
    }
}
